<template>
  <v-btn @click="chatWithUs" class="mx-auto" color="light-blue" text>
    <v-icon small>mdi-chat</v-icon>
    <span class="ml-2">{{ $t("s1656805768") }}</span>
  </v-btn>
</template>

<script>
export default {
  name: "TawkChatComponent",
  methods: {
    chatWithUs() {
      this.$tawkMessenger.maximize();
    }
  }
};
</script>

<style></style>
